import { css } from 'styled-components';
import type { STagProps } from '../Tag';

export const BaseTagStyles = css<Pick<STagProps, 'variant'>>`
  ${({ theme, variant }) =>
    variant === 'SMALL'
      ? theme.donedeal.fontSize.B10
      : theme.donedeal.fontSize.B12};
  padding: ${({ theme, variant }) =>
    variant === 'SMALL' ? `0 ${theme.spacing.S4}` : theme.spacing.S4};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  height: ${({ variant }) => (variant === 'SMALL' ? '16px' : '24px')};
  background: ${({ theme }) => theme.donedeal.colors.GREY_LIGHTER};
  display: inline-flex;
  align-items: center;
`;
